import ConfirmationModal from "../../shared/components/ConfirmationModal";
import { formatTranslation } from "../../shared/utils/translationUtils";
import { useTranslation } from "react-i18next";

/**
 * CompletionConfirmationModal component displays confirmation modals for trial completion and incomplete data scenarios.
 * @param param0 - Props for the component.
 * @returns JSX.Element
 */
const CompletionConfirmationModal = ({
  completionModalOpen,
  handleCompletionModalCancel,
  handleCompletionModalProceed,
  completionStatus,
}: {
  completionModalOpen: boolean;
  handleCompletionModalCancel: () => void;
  handleCompletionModalProceed: () => void;
  completionStatus: boolean | null;
}): JSX.Element => {
  const { t } = useTranslation();
  let modalProps = {
    title: formatTranslation(t("trials.completionModal.title")),
    description: formatTranslation(t("trials.completionModal.description")),
    cancelText: formatTranslation(t("trials.completionModal.cancel")),
    confirmText: formatTranslation(t("trials.completionModal.proceed")),
    confirmDanger: true,
  };
  if (completionStatus) {
    modalProps = {
      title: formatTranslation(t("trials.incompleteModal.title")),
      description: formatTranslation(t("trials.incompleteModal.description")),
      cancelText: formatTranslation(t("trials.incompleteModal.cancel")),
      confirmText: formatTranslation(t("trials.incompleteModal.completeData")),
      confirmDanger: false,
    };
  }

  return (
    <ConfirmationModal
      open={completionModalOpen}
      title={modalProps.title}
      description={modalProps.description}
      cancelText={modalProps.cancelText}
      confirmText={modalProps.confirmText}
      onCancel={handleCompletionModalCancel}
      onConfirm={handleCompletionModalProceed}
      confirmDanger={modalProps.confirmDanger}
    />
  );
};

export default CompletionConfirmationModal;
